import { Loader2 } from "lucide-react";
import { VOICE_STATUS } from "@/lib/sunoVoicesApi";

const TONES = {
  wait: "bg-amber-300/10 text-amber-100",
  todo: "bg-cyan-300/15 text-cyan-100",
  good: "bg-emerald-400/15 text-emerald-100",
  bad: "bg-rose-500/15 text-rose-100",
};

export default function VoiceStatusChip({ status, testId }) {
  const s = VOICE_STATUS[status] || VOICE_STATUS.error;
  return (
    <span data-testid={testId} data-status={status} className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[12px] ${TONES[s.tone]}`}>
      {s.tone === "wait" ? <Loader2 className="h-3 w-3 animate-spin" /> : null}{s.label}
    </span>
  );
}
